import { t } from '@/lang'
import { OptionItem, paymentRecordStatusConfigType } from './index.d'
import {
  GrantOrderStatus,
  TransactionStatus,
  GrantOrderType,
} from '@pt/enums/grant'

export const paymentRecordStatusOptions: OptionItem[] = [
  {
    label: t('playTurbo.payment.record.payment.status.pending').toString(),
    value: GrantOrderStatus.Pending,
  },
  {
    label: t('playTurbo.payment.record.payment.status.success').toString(),
    value: GrantOrderStatus.Success,
  },
  {
    label: t('playTurbo.payment.record.payment.status.failed').toString(),
    value: GrantOrderStatus.Failed,
  },
  {
    label: t('playTurbo.payment.record.payment.status.canceled').toString(),
    value: GrantOrderStatus.Canceled,
  },
  {
    label: t('playTurbo.payment.record.payment.status.warning').toString(),
    value: GrantOrderStatus.Confirming,
  },
]

export const paymentRecordStatusConfig: paymentRecordStatusConfigType = {
  [GrantOrderStatus.Pending]: {
    color: 'fail',
    label: t('playTurbo.payment.record.payment.status.pending').toString(),
  },
  [GrantOrderStatus.Success]: {
    color: 'success',
    label: t('playTurbo.payment.record.payment.status.success').toString(),
  },
  [GrantOrderStatus.Failed]: {
    color: 'fail',
    label: t('playTurbo.payment.record.payment.status.failed').toString(),
  },
  [GrantOrderStatus.Canceled]: {
    color: 'pending',
    label: t('playTurbo.payment.record.payment.status.canceled').toString(),
  },
  [GrantOrderStatus.Confirming]: {
    color: 'warning',
    label: t('playTurbo.payment.record.payment.status.warning').toString(),
  },
}

export const transactionStatusConfig: { [key: string]: { label: string } } = {
  [TransactionStatus.FailedPay]: {
    label: '收款失败',
  },
  [TransactionStatus.SuccessConfirm]: {
    label: '财务做账完成',
  },
  [TransactionStatus.SuccessPay]: {
    label: '收款成功',
  },
  [TransactionStatus.WaitPay]: {
    label: '待收款',
  },
}

export const grantOrderTypeConfig: { [key: string]: { label: string } } = {
  [GrantOrderType.PackBuy]: {
    label: t('playTurbo.payment.record.grantOrderType.packBuy').toString(),
  },
  [GrantOrderType.PackageBuy]: {
    label: t('playTurbo.payment.record.grantOrderType.packageBuy').toString(),
  },
  [GrantOrderType.Recharge]: {
    label: t('playTurbo.payment.record.grantOrderType.recharge').toString(),
  },
}

export const grantOrderTypeOptions = [
  {
    label: grantOrderTypeConfig[GrantOrderType.PackageBuy]!.label,
    value: GrantOrderType.PackageBuy,
  },
  {
    label: grantOrderTypeConfig[GrantOrderType.PackBuy]!.label,
    value: GrantOrderType.PackBuy,
  },
  {
    label: grantOrderTypeConfig[GrantOrderType.Recharge]!.label,
    value: GrantOrderType.Recharge,
  },
]
